/* ===========================================================
   Myoform — The New Standard carousel
   The track stays a native scroller, so touch swiping and
   keyboard scrolling keep working as-is. This adds the two
   things a desktop pointer has no way to do otherwise: arrow
   buttons and click-and-drag scrolling.
   =========================================================== */

(function () {
  /* Pointer travel before a press counts as a drag rather than a click. */
  var DRAG_THRESHOLD = 6;

  function Carousel(root) {
    this.root = root;
    this.scroller = root.querySelector('[data-the-new-standard-scroll]');
    this.prev = root.querySelector('[data-the-new-standard-prev]');
    this.next = root.querySelector('[data-the-new-standard-next]');

    this.pointerId = null;
    this.startX = 0;
    this.startScroll = 0;
    this.dragged = false;
  }

  Carousel.prototype.step = function () {
    var slide = this.scroller.querySelector('.tns__slide');
    if (!slide) return this.scroller.clientWidth * 0.8;

    var gap = parseFloat(window.getComputedStyle(slide.parentNode).columnGap) || 0;
    return slide.getBoundingClientRect().width + gap;
  };

  Carousel.prototype.scrollBy = function (direction) {
    var reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.scroller.scrollBy({
      left: this.step() * direction,
      behavior: reduced ? 'auto' : 'smooth',
    });
  };

  Carousel.prototype.update = function () {
    var max = this.scroller.scrollWidth - this.scroller.clientWidth;
    var at = this.scroller.scrollLeft;

    this.root.classList.toggle('tns__carousel--static', max <= 1);
    if (this.prev) this.prev.disabled = at <= 1;
    if (this.next) this.next.disabled = at >= max - 1;
  };

  Carousel.prototype.endDrag = function () {
    if (this.pointerId === null) return;

    try {
      this.scroller.releasePointerCapture(this.pointerId);
    } catch (error) {
      /* Capture is already gone when the pointer left the window. */
    }

    this.pointerId = null;
    this.scroller.classList.remove('is-dragging');
  };

  Carousel.prototype.bind = function () {
    var self = this;

    if (this.prev) {
      this.prev.addEventListener('click', function () {
        self.scrollBy(-1);
      });
    }

    if (this.next) {
      this.next.addEventListener('click', function () {
        self.scrollBy(1);
      });
    }

    this.scroller.addEventListener('scroll', function () {
      self.update();
    });

    window.addEventListener('resize', function () {
      self.update();
    });

    this.scroller.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;

      self.pointerId = event.pointerId;
      self.startX = event.clientX;
      self.startScroll = self.scroller.scrollLeft;
      self.dragged = false;
      self.scroller.setPointerCapture(event.pointerId);
    });

    this.scroller.addEventListener('pointermove', function (event) {
      if (self.pointerId !== event.pointerId) return;

      var distance = event.clientX - self.startX;
      if (!self.dragged && Math.abs(distance) < DRAG_THRESHOLD) return;

      if (!self.dragged) {
        self.dragged = true;
        self.scroller.classList.add('is-dragging');
      }

      event.preventDefault();
      self.scroller.scrollLeft = self.startScroll - distance;
    });

    this.scroller.addEventListener('pointerup', function (event) {
      if (self.pointerId !== event.pointerId) return;
      self.endDrag();
    });

    this.scroller.addEventListener('pointercancel', function (event) {
      if (self.pointerId !== event.pointerId) return;
      self.dragged = false;
      self.endDrag();
    });

    /* A drag that ends on a card would otherwise follow its link. */
    this.scroller.addEventListener(
      'click',
      function (event) {
        if (!self.dragged) return;
        self.dragged = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    this.scroller.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    this.update();
  };

  function init(root) {
    if (root.dataset.theNewStandardReady === 'true') return;

    var carousel = new Carousel(root);
    if (!carousel.scroller) return;

    root.dataset.theNewStandardReady = 'true';
    carousel.bind();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-the-new-standard-carousel]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
